import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function CalendarIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 14 14'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.84375 2.84375V11.1562H11.1562V2.84375H2.84375ZM1.53125 2.625C1.53125 2.02094 2.02094 1.53125 2.625 1.53125H11.375C11.9791 1.53125 12.4688 2.02094 12.4688 2.625V11.375C12.4688 11.9791 11.9791 12.4688 11.375 12.4688H2.625C2.02094 12.4688 1.53125 11.9791 1.53125 11.375V2.625Z'
        fill={props.fill ?? '#B8BABF'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.625 0.4375C9.98744 0.4375 10.2812 0.731313 10.2812 1.09375V2.1875C10.2812 2.54994 9.98744 2.84375 9.625 2.84375C9.26256 2.84375 8.96875 2.54994 8.96875 2.1875V1.09375C8.96875 0.731313 9.26256 0.4375 9.625 0.4375Z'
        fill={props.fill ?? '#B8BABF'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.375 0.4375C4.73744 0.4375 5.03125 0.731313 5.03125 1.09375V2.1875C5.03125 2.54994 4.73744 2.84375 4.375 2.84375C4.01256 2.84375 3.71875 2.54994 3.71875 2.1875V1.09375C3.71875 0.731313 4.01256 0.4375 4.375 0.4375Z'
        fill={props.fill ?? '#B8BABF'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.53125 4.8125C1.53125 4.45006 1.82506 4.15625 2.1875 4.15625H11.8125C12.1749 4.15625 12.4688 4.45006 12.4688 4.8125C12.4688 5.17494 12.1749 5.46875 11.8125 5.46875H2.1875C1.82506 5.46875 1.53125 5.17494 1.53125 4.8125Z'
        fill={props.fill ?? '#B8BABF'}
      />
    </SvgIcon>
  );
}
